export default __webpack_public_path__ + "static/media/message-outline-32px.97eaf6fa.svg";